import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";

/** Outlet context provided by BackofficeLayout to register the active page title. */
export interface BackofficeOutletContext {
  setTitle: (title?: string) => void;
}

export function useBackofficeTopBarTitle(title?: string): void {
  const { setTitle } = useOutletContext<BackofficeOutletContext>();

  useEffect(() => {
    setTitle(title);
    return () => setTitle(undefined);
  }, [title, setTitle]);
}
